<template>
  <EmptyData
    :data="!value || value.length === 0"
    :image="'empty-materials.svg'"
    imgSize="h-40"
  />
  <section class="flex flex-col gap-3 max-h-[350px] overflow-auto scroll-style">
    <Draggable v-model="value" itemKey="index" @end="onEnd">
      <template #item="{ element, index }">
        <div
          class="bg-gray-50 rounded shadow border px-5 py-2 my-3 cursor-pointer"
        >
          <div class="flex items-center justify-between">
            <p class="text-lg truncate max-w-lg font-bold">
              {{ element.name }}
            </p>

            <div class="flex items-center gap-2">
              <Button
                class="btn-simple"
                @click.prevent="$emit('onEdit', element)"
              >
                <v-icon name="md-edit" class="text-h-primary-500" />
              </Button>
              <Button
                class="btn-delete"
                @click.prevent="onDelete(element)"
                :disabled="loading"
              >
                <v-icon
                  v-if="loading && currentItem === element"
                  name="ri-loader-5-fill"
                  class="text-red-700 animate-spin"
                />
                <v-icon v-else name="md-delete" :class="['text-red-700']" />
              </Button>
              <OrderButtons
                :all-data="value"
                :data="element"
                :index="index"
                @on-order="generics.onOrder($event, index, value, updateOrder)"
              />
            </div>
          </div>
        </div>
      </template>
    </Draggable>
  </section>
</template>

<script lang="ts">
import { Material } from "@/models/material.model";
import { MaterialsRest } from "@/services/rest/materials.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Order",
  emits: ["onDelete", "onEdit", "update:data", "update:loader"],
  props: {
    data: {
      type: Array as PropType<Material[]>,
      default: [],
    },
    loader: { type: Boolean, default: false },
    lessonId: String,
  },
  setup() {
    const generics = computed(() => new GenericsUtils());
    const rest = computed(() => new MaterialsRest());
    return { generics, rest };
  },
  data() {
    return {
      currentItem: {} as Material,
    };
  },
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(value) {
        this.$emit("update:data", value);
      },
    },
    loading: {
      get() {
        return this.loader;
      },
      set(value) {
        this.$emit("update:loader", value);
      },
    },
  },
  methods: {
    updateOrder(prev: number, next: number): void {
      const newOrder = [
        { ...this.value[prev], index: prev, createdAt: undefined },
        { ...this.value[next], index: next, createdAt: undefined },
      ];

      this.rest.orderMaterials(this.lessonId!, newOrder).subscribe({
        next: () => {},
        complete: () => {},
      });
    },
    onEnd(event: { oldIndex: number; newIndex: number }): void {
      const prevIndex = event.oldIndex;
      const newIndex = event.newIndex;
      if (prevIndex !== newIndex) {
        this.updateOrder(prevIndex, newIndex);
      }
    },
    onDelete(item: Material): void {
      this.$emit("onDelete", item);
      this.currentItem = item;
    },
  },
});
</script>
